export default __webpack_public_path__ + "static/media/EDU.b00dfcb0.jpg";